module.exports = __webpack_public_path__ + "static/folders-organise-share-your-projects-b53ab42b78f239a6e408e13c0502660a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/folders-organise-share-your-projects.png
// module id = 2687
// module chunks = 157636680307020